import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['content', 'icon']
  static values = {
    open: { type: Boolean, default: false }
  }

  connect() {
    if (this.openValue) {
      this.contentTarget.classList.add('accordion__content--open')
      if (this.hasIconTarget) this.iconTarget.classList.add('accordion__icon--open')
    }
  }

  toggleDisplay() {
    if (this.contentTarget.classList.contains('accordion__content--open')) {
      this.contentTarget.classList.remove('accordion__content--open')
      if (this.hasIconTarget) this.iconTarget?.classList.remove('accordion__icon--open')
    } else {
      this.contentTarget.classList.add('accordion__content--open')
      if (this.hasIconTarget) this.iconTarget.classList.add('accordion__icon--open')

      document.dispatchEvent(new CustomEvent('accordion:opened'))
    }
  }
}
